module.exports = __webpack_public_path__ + "img/puretrack-logo.6550d99f.png";